import { Container } from "reactstrap";
import PushNotificationRightSide from "./PushNotificationRightSide";
import { useState } from "react";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { PushNotificationData } from "./types";

const PushNotificationBoxContainer = () => {
  const { t } = useTranslation();
  const [composePushNotification, setComposePushNotification] = useState(false);
  const [pushNotificationValidation, setPushNotificationValidation] =
    useState(false);
  const [searchWord, setSearchWord] = useState("");
  const [pushNotifications, setPushNotifications] = useState<
    PushNotificationData[]
  >([
    {
      id: "11",
      recipientRoles: ["Developers", "Admins"],
      title: "Server Maintenance",
      message: "Maintenance scheduled tomorrow.",
      description: "Scheduled for 1:00 AM to 3:00 AM IST tomorrow.",
      time: "11:50 AM",
      status: "sent",
      priority: [{ title: "High", color: "danger" }],
      notificationType: "warning",
    },
    {
      id: "12",
      recipientRoles: ["Sales", "Team A"],
      title: "System Update",
      message: "New API endpoints available.",
      description: "New API endpoints available today.",
      time: "12:00 PM",
      status: "delivered",
      priority: [{ title: "Medium", color: "info" }],
      notificationType: "info",
    },
    {
      id: "13",
      recipientRoles: ["Team B", "Managers", "Admins"],
      title: "Security Patch",
      message: "Apply updates by 6:00 PM.",
      description: "Apply updates by 6:00 PM IST.",
      time: "12:10 PM",
      status: "pending",
      priority: [{ title: "High", color: "danger" }],
      notificationType: "error",
    },
    {
      id: "14",
      recipientRoles: ["Developers", "Sales", "Team A", "Team B"],
      title: "Database Optimization",
      message: "Expect minor delays tonight.",
      description: "Expect minor delays this evening.",
      time: "12:20 PM",
      status: "sent",
      priority: [{ title: "Medium", color: "warning" }],
      notificationType: "warning",
    },
    {
      id: "15",
      recipientRoles: ["Team A", "Team B"],
      title: "Feedback Request",
      message: "Share system feedback.",
      time: "12:30 PM",
      status: "delivered",
      priority: [{ title: "Low", color: "light" }],
      notificationType: "info",
    },
  ]);

  const handleAddPushNotification = (newPushNotification: {
    recipientRoles: string;
    title: string;
    message: string;
    notificationType: "warning" | "info" | "success" | "error";
  }) => {
    setPushNotifications([
      ...pushNotifications,
      {
        id: `${pushNotifications.length + 1}`,
        recipientRoles: newPushNotification.recipientRoles
          .split(",")
          .map((role) => role.trim()),
        title: newPushNotification.title,
        message: newPushNotification.message,
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        status: "pending",
        priority: [{ title: "Low", color: "light" }],
        notificationType: newPushNotification.notificationType,
      },
    ]);
    setComposePushNotification(false);
    setPushNotificationValidation(false);
  };

  return (
    <>
      <Breadcrumbs
        mainTitle={t("Push Notification")}
        parent={t("Communication")}
      />
      <Container fluid>
        <PushNotificationRightSide
          setComposePushNotification={setComposePushNotification}
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          pushNotifications={pushNotifications}
        />
      </Container>
    </>
  );
};

export default PushNotificationBoxContainer;
